import React from "react";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const StartClick = () => {
    return(
        <div className="start-click">
            <div className="start-arrow"><ArrowBackIcon fontSize="inherit"/></div>
            <h3>Click Letter</h3>
        </div>
    )
}

export default StartClick;